import { render, staticRenderFns } from "./PrescriptionView.vue?vue&type=template&id=419aa618"
import script from "./PrescriptionView.vue?vue&type=script&lang=js"
export * from "./PrescriptionView.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionView.vue?vue&type=style&index=0&id=419aa618&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports